import { render, staticRenderFns } from "./loginChangeTrainsUserSaml.vue?vue&type=template&id=437be535&"
import script from "./loginChangeTrainsUserSaml.vue?vue&type=script&lang=ts&"
export * from "./loginChangeTrainsUserSaml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports